var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'background-color': _vm.bgcolors}),attrs:{"id":"overlay-circular"}},[_c('div',{staticClass:"loader-circular"})])
}
var staticRenderFns = []

export { render, staticRenderFns }